export default __webpack_public_path__ + "static/media/wl-ico.396de5e8.svg";